import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';

import { MessageSimple } from 'src/app/models/message-simple';

@Component({
  selector: 'app-message-simple',
  templateUrl: './message-simple.component.html',
  styleUrls: ['./message-simple.component.scss']
})
export class MessageSimpleComponent implements OnInit {

  @Input() messageSimple:MessageSimple;
  @Input() isEdit:boolean = false;
  @Input() hasBack:boolean = false;
  @Output() messageSimpleforwardClicked:EventEmitter<MessageSimple> = new EventEmitter();
  @Output() backToTop = new EventEmitter();
  @Output() linkClick: EventEmitter<{content:MessageSimple, linkUrl:string, title:string}> = new EventEmitter();

  @ViewChild('descriptionElement', {static: false}) descriptionElement:ElementRef;

  constructor() { }

  ngOnInit() {
  }

  ngAfterViewInit(){
    if(this.descriptionElement){
      const aElements = this.descriptionElement.nativeElement.querySelectorAll("a");
      console.log(aElements);
      aElements.forEach((aElement) => {
        aElement.addEventListener("click", (event) => {this.linkClicked(event)});
      });
    }
  }

  linkClicked(event){
    const link = event.target.getAttribute("href");
    const title = event.target.innerText;
    this.linkClick.emit({content:this.messageSimple, linkUrl:link, title:title});
  }

  backToTopClicked(){
    this.backToTop.emit();
  }

  forwardClicked(){
    this.messageSimpleforwardClicked.emit(this.messageSimple);
  }

}